'use strict';

const FormInput =  React.lazy(() => import( /* webpackChunkName: "FormInput" */ '../components/FormInput'));

class PdfModal extends React.Component {
    constructor(props) {
        super(props);
        this.initState = {
            type: null,
            url: null,
            price: '',
            comment: '',
        }
        this.state = this.initState;
    }

    componentDidMount() {
        listenEvent('react.editPdf', data => {
            if(data === null) {
                this.setState(this.initState);
            } else {
                this.setState({
                    type: data.type,
                    url: data.url,
                });
            }
        })
    }

    handleSubmit() {
        $('#pdfModalForm').submit();
        $.fancybox.close();
    }

    render() {
        const {url, type, price, comment} = this.state;

        let title = __('[Pdf][Modal] Offer title');
        let text = __('[Pdf][Modal] Offer text');
        if(type === 'confirm') {
            title = __('[Pdf][Modal] Confirm title');
            text = __('[Pdf][Modal] Confirm text');
        }
        if(type === 'details') {
            title = __('[Pdf][Modal] Details title');
            text = __('[Pdf][Modal] Details text');
        }

        return <div>
            <form id="pdfModalForm" action={url} method="post" target="_blank">
                <input type="hidden" name="price" value={price}/>
                <input type="hidden" name="comment" value={comment}/>
            </form>

            <div className="modal-title text-center">
                {title}
            </div>
            <div className="modal-text">
                <p>{text}</p>
            </div>
            <div className="offer-form">
                <div className="offer-form__row">
                    <React.Suspense>
                        <FormInput
                            className={'plane-input'}
                            label={__('[Pdf][Modal] Price')}
                            value={price}
                            onChange={price => this.setState({
                                                   price: price.replace(/[^\d]*/g, '')
                                                   })}
                        />
                    </React.Suspense>
                </div>
                <div className="offer-form__row">
                    <React.Suspense>
                        <FormInput
                            type={'textarea'}
                            className={'offer-form__textarea'}
                            label={__('[Pdf][Modal] Comment')}
                            value={comment}
                            multiLine={true}
                            onChange={comment => this.setState({comment})}
                        />
                    </React.Suspense>
                </div>
            </div>
            <div className="modal-btn">
                <button className="button button-base" onClick={this.handleSubmit}>{__('[Pdf][Modal] Download')}</button>
            </div>
        </div>
    }
}

const domContainer = document.querySelector('#reactPdfModal');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(PdfModal));
